export default {
    name: 'publik',
    state: {
        isPublik: false
    },
    getters: {
        getIsPublik: state => {
            return state.isPublik
        },
    },
    mutations: {
        PUBLIK: (state, payload) => {
            state.isPublik = payload;
        }
    },
    actions: {
        SET_PUBLIK(store, payload) {
            console.log('payload');
            console.log(payload);
            store.commit('PUBLIK', payload)
        }
    }
}